module.exports = __webpack_public_path__ + "static/img/success_icon.720ce3c8.png";